import React from 'react';

import { useWatchlist } from '~/stores/use-watchlist/useWatchlist';

import * as S from './Dashboard.styles';
import { IndicatorWidget } from './indicator-widget/IndicatorWidget';
import { MyAssetsWidget } from './my-assets-widget/MyAssetsWidget';
import { NewsWidget } from './news-widget/NewsWidget';

export const Dashboard = () => {
  const lists = useWatchlist(state => state.lists);

  return (
    <S.MainContent data-testid="dashboard">
      <S.WidgetsDashboard>
        <S.MidContainer>
          <IndicatorWidget />
        </S.MidContainer>
        <S.LeftWidgetContainer>
          <NewsWidget isGrid={false} />
        </S.LeftWidgetContainer>
        <S.RightWidgetContainer>
          <div>CALENDAR PLACEHOLDER</div>
        </S.RightWidgetContainer>
        <S.BottomContainer>
          <MyAssetsWidget lists={lists} />
        </S.BottomContainer>
      </S.WidgetsDashboard>
    </S.MainContent>
  );
};
